import Crown from './Crown/Crown';

const templates = {
  Crown,
};

export default templates;